// extracted by mini-css-extract-plugin
module.exports = {"action":"SummaryList__action--VY5SA","table":"SummaryList__table--3RtML m-table-item","empty_messages":"SummaryList__empty_messages--1D1GC"};